module.exports = function() {
  return new Worker(__webpack_public_path__ + "9f3eec3cbbbd4a1b733f.worker.js");
};